var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.66667 6.66667H5.16683C4.23341 6.66667 3.76635 6.66667 3.40983 6.84832C3.09623 7.00811 2.84144 7.26289 2.68166 7.5765C2.5 7.93302 2.5 8.40008 2.5 9.3335V14.0002C2.5 14.9336 2.5 15.4 2.68166 15.7566C2.84144 16.0702 3.09623 16.3254 3.40983 16.4852C3.766 16.6667 4.23249 16.6667 5.16409 16.6667H14.8359C15.7675 16.6667 16.2333 16.6667 16.5895 16.4852C16.9031 16.3254 17.1587 16.0702 17.3185 15.7566C17.5 15.4004 17.5 14.9346 17.5 14.003V9.33076C17.5 8.39916 17.5 7.93267 17.3185 7.5765C17.1587 7.26289 16.9031 7.00811 16.5895 6.84832C16.233 6.66667 15.7669 6.66667 14.8335 6.66667H13.3333M6.66667 6.66667H13.3333M6.66667 6.66667C6.66667 4.82572 8.15905 3.33333 10 3.33333C11.8409 3.33333 13.3333 4.82572 13.3333 6.66667",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavWork);
export default __webpack_public_path__ + "static/media/nav-work.e71df778c9780b752b4de994f63e2542.svg";
export { ForwardRef as ReactComponent };